import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as studyActions from '../../actions/studyActions';
import * as insight360Actions from '../../actions/insight360Actions';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import CommonStudySelector from '../common/CommonStudySelector';
import { PREFERENCE_CROSSTAB, PREFERENCE_STUDY_WEIGHTING,
  PREFERENCE_QUICKREPORTS, PREFERENCE_DATAHAUL, PREFERENCE_STORIES, FLEX_STUDY_TAG,
  CROSSTAB_FEATUREID, QUICKREPORTS_FEATUREID, DATAHAUL_FEATUREID, STORIES_FEATUREID,
  BRAND_CATALYST_FEATUREID, SALES_CATALYST_FEATUREID, MME_FEATUREID } from '../../constants';
import { filterStudies, getStudyFromStudies, filterStudyList,
 getStudyFamilyIdForGivenProductNo } from '../../util/CommonUtils';

class PreferencesCommonStudySelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      studies: [],
      // style: {},
      selectedStudy: {},
      hideWeightType: false,
      showWeightType: true,
    };
  }

  componentDidMount() {
    const { menuName, defaultValue } = this.props.field;
    this.getStudiesForModule(menuName, defaultValue);
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.studies
      && this.props.field.menuName === 'Crosstab') {
      if (!_.isEmpty(nextProps.userPreference) && _.isEmpty(this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEmpty(this.props.userPreference) &&
      !_.isEqual(nextProps.userPreference, this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEqual(this.props.studies, nextProps.studies)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      }
    } else if (nextProps.studies &&
      this.props.field.menuName === 'QuickReports') {
      if (!_.isEmpty(nextProps.userPreference) && _.isEmpty(this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEmpty(this.props.userPreference) &&
      !_.isEqual(nextProps.userPreference, this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEqual(this.props.studies, nextProps.studies)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      }
    } else if (nextProps.studies &&
      this.props.field.menuName === 'DataHaul') {
      if (!_.isEmpty(nextProps.userPreference) && _.isEmpty(this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEmpty(this.props.userPreference) &&
      !_.isEqual(nextProps.userPreference, this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEqual(this.props.studies, nextProps.studies)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      }
    } else if (nextProps.studies &&
      this.props.field.menuName === 'Stories') {
      if (!_.isEmpty(nextProps.userPreference) && _.isEmpty(this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEmpty(this.props.userPreference) &&
      !_.isEqual(nextProps.userPreference, this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEqual(this.props.studies, nextProps.studies)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      }
    }

    if (nextProps.bcStudies && this.props.field.menuName === 'BrandCatalyst') {
      if (!_.isEmpty(nextProps.userPreference) && _.isEmpty(this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEmpty(this.props.userPreference) &&
      !_.isEqual(nextProps.userPreference, this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEqual(this.props.bcStudies, nextProps.bcStudies)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      }
      //
    }

    if (nextProps.scStudies && this.props.field.menuName === 'SalesCatalyst') {
      if (!_.isEmpty(nextProps.userPreference) && _.isEmpty(this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEmpty(this.props.userPreference) &&
      !_.isEqual(nextProps.userPreference, this.props.userPreference)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      } else if (!_.isEqual(this.props.scStudies, nextProps.scStudies)) {
        this.updatePreferenceStudyForModule(nextProps, this.props.field.menuName);
      }
    }
  }

  getStudiesForModule = (activeModule, defaultValue) => {
    switch (activeModule) {
      case 'BrandCatalyst': {
        let selectedStudy;
        if (this.props.bcStudies && this.props.bcStudies.length > 0) {
          if (defaultValue !== -1) {
            selectedStudy = getStudyFromStudies(
              filterStudyList(this.props.bcStudies, BRAND_CATALYST_FEATUREID),
              defaultValue
            );
          } else {
            selectedStudy = this.props.bcStudies[0].sl[0];
          }
          this.setState(() => ({
            studies: this.props.bcStudies,
            // style: this.props.field.style,
            selectedStudy,
            hideWeightType: true,
            showWeightType: false,
          }));
        } else {
          this.props.insight360Actions.get360Study(
            this.props.loginResponse.data.token,
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
          );
        }
        break;
      }
      case 'SalesCatalyst': {
        let selectedStudy;
        if (this.props.scStudies && this.props.scStudies.length > 0) {
          if (defaultValue !== -1) {
            selectedStudy = getStudyFromStudies(
              filterStudyList(this.props.scStudies, SALES_CATALYST_FEATUREID),
              defaultValue
            );
          } else {
            selectedStudy = this.props.scStudies[0].sl[0];
          }
          this.setState(() => ({
            studies: this.props.scStudies,
            // style: this.props.field.style,
            selectedStudy,
            hideWeightType: true,
            showWeightType: false,
          }));
        } else {
          this.props.salesCatalystActions.getsalesCatalystStudy(
            this.props.loginResponse.data.token,
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
          );
        }
        break;
      }
      default: {
        if (this.props.studies && this.props.studies.length > 0) {
          let selectedStudy;
          let studies;
          let activeScreen;
          let feature;
          const keys = this.props.field.dbKey.split('.');

          if (keys[0] === PREFERENCE_CROSSTAB) {
            activeScreen = PREFERENCE_CROSSTAB;
            studies = this.props.studies;
            feature = CROSSTAB_FEATUREID;
          } else if (keys[0] === PREFERENCE_QUICKREPORTS) {
            activeScreen = PREFERENCE_QUICKREPORTS;
            studies = filterStudies(this.props.studies, FLEX_STUDY_TAG);
            feature = QUICKREPORTS_FEATUREID;
          } else if (keys[0] === PREFERENCE_DATAHAUL) {
            activeScreen = PREFERENCE_DATAHAUL;
            studies = filterStudies(this.props.studies, FLEX_STUDY_TAG);
            feature = DATAHAUL_FEATUREID;
          } else if (keys[0] === PREFERENCE_STORIES) {
            activeScreen = PREFERENCE_STORIES;
            studies = filterStudies(this.props.studies, FLEX_STUDY_TAG);
            feature = STORIES_FEATUREID;
          }

          const studyList = filterStudyList(this.props.studies, feature);

          if (defaultValue !== -1) {
            selectedStudy = getStudyFromStudies(studyList, defaultValue);
          } else {
            selectedStudy = studyList[0].sl[0];
          }
          const modifiedPreferences = this.props.modifiedPreferences;
          let weightType;
          if (_.isEmpty(modifiedPreferences)) {
            weightType = 1;
          } else {
            weightType = this.props.modifiedPreferences[activeScreen][PREFERENCE_STUDY_WEIGHTING] === 'Population' ?
             1 : 2;
          }
          selectedStudy = {
            ...selectedStudy,
            wt: weightType,
          };
          const hideWeightType = this.props.weightTypeStudies && this.props.weightTypeStudies.some(el => {
            return el.pn === selectedStudy.pn;
          });
          const selectedWeightType = typeof (this.props.userPreference[keys[0]][PREFERENCE_STUDY_WEIGHTING]) 
            === 'string' || this.props.userPreference[keys[0]][PREFERENCE_STUDY_WEIGHTING].wt === undefined ?
            selectedStudy.cw[0] : this.props.userPreference[keys[0]][PREFERENCE_STUDY_WEIGHTING];
          this.setState(() => ({
            studies,
            selectedWeightType,
            // style: this.props.field.style,
            selectedStudy,
            hideWeightType,
          }));
        }
      }
    }
  }

  updatePreferenceStudyForModule = (nextProps, menuName) => {
    let selectedStudy;
    if (menuName === 'Crosstab') {
      const studyList = filterStudyList(nextProps.studies, CROSSTAB_FEATUREID);
      if (!_.isEmpty(nextProps.userPreference) && nextProps.userPreference._ct._ds !== -1) {
        selectedStudy = getStudyFromStudies(studyList, nextProps.userPreference._ct._ds);
      } else {
        selectedStudy = studyList[0].sl[0];
      }
      selectedStudy = {
        ...selectedStudy,
        wt:
        nextProps.userPreference[PREFERENCE_CROSSTAB][PREFERENCE_STUDY_WEIGHTING]
        === 'Population' ?
         1 : 2,
      };
      const studyFamilyId = getStudyFamilyIdForGivenProductNo(selectedStudy.pn, studyList);
      const updatedWeightType = nextProps.userPreference[PREFERENCE_CROSSTAB][PREFERENCE_STUDY_WEIGHTING];
      if (typeof (updatedWeightType) === 'object') {
        updatedWeightType.sd = studyFamilyId;
      }
      const hideWeightType = this.props.weightTypeStudies &&
      this.props.weightTypeStudies.some(el => {
        return el.pn === selectedStudy.pn;
      });
      this.props.studyActions.updateWeightType(menuName, updatedWeightType);
      this.setState(() => ({
        studies: filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
        // style: this.props.field.style,
        selectedStudy,
        hideWeightType,
      }));
    } else if (menuName === 'QuickReports') {
      const studyList = filterStudyList(nextProps.studies, QUICKREPORTS_FEATUREID);
      if (!_.isEmpty(nextProps.userPreference) && nextProps.userPreference._qr._ds !== -1) {
        selectedStudy = getStudyFromStudies(studyList, nextProps.userPreference._qr._ds);
      } else {
        selectedStudy = studyList[0].sl[0];
      }
      selectedStudy = {
        ...selectedStudy,
        wt:
        nextProps.userPreference[PREFERENCE_QUICKREPORTS][PREFERENCE_STUDY_WEIGHTING]
        === 'Population' ?
        1 : 2,
      };
      const hideWeightType = this.props.weightTypeStudies &&
      this.props.weightTypeStudies.some(el => {
        return el.pn === selectedStudy.pn;
      });
      const qrStudies = filterStudies(filterStudyList(this.props.studies, QUICKREPORTS_FEATUREID), FLEX_STUDY_TAG);
      const qrSGD = getStudyFamilyIdForGivenProductNo(selectedStudy.pn, qrStudies);
      const updatedWeightType = nextProps.userPreference[PREFERENCE_QUICKREPORTS][PREFERENCE_STUDY_WEIGHTING];
      if (typeof (updatedWeightType) === 'object') {
        updatedWeightType.sd = qrSGD;
      }
      this.props.studyActions.updateWeightType(menuName, updatedWeightType);
      this.setState(() => ({
        studies: filterStudies(filterStudyList(this.props.studies, QUICKREPORTS_FEATUREID), FLEX_STUDY_TAG),
        // style: this.props.field.style,
        selectedStudy,
        hideWeightType,
      }));
    } else if (menuName === 'DataHaul') {
      const studyList = filterStudyList(nextProps.studies, DATAHAUL_FEATUREID);
      if (!_.isEmpty(nextProps.userPreference) && nextProps.userPreference._dh._ds !== -1) {
        selectedStudy = getStudyFromStudies(studyList, nextProps.userPreference._dh._ds);
      } else {
        selectedStudy = studyList[0].sl[0];
      }
      selectedStudy = {
        ...selectedStudy,
        wt:
        nextProps.userPreference[PREFERENCE_DATAHAUL][PREFERENCE_STUDY_WEIGHTING]
        === 'Population' ?
        1 : 2,
      };
      const hideWeightType = this.props.weightTypeStudies &&
      this.props.weightTypeStudies.some(el => {
        return el.pn === selectedStudy.pn;
      });
      const studyFamilyId = getStudyFamilyIdForGivenProductNo(
        selectedStudy.pn, filterStudies(filterStudyList(this.props.studies, DATAHAUL_FEATUREID), FLEX_STUDY_TAG));
      const updatedWeightType = nextProps.userPreference[PREFERENCE_DATAHAUL][PREFERENCE_STUDY_WEIGHTING];
      if (typeof (updatedWeightType) === 'object') {
        updatedWeightType.sd = studyFamilyId;
      }
      this.props.studyActions.updateWeightType(menuName, updatedWeightType);
      this.setState(() => ({
        studies: filterStudies(filterStudyList(this.props.studies, DATAHAUL_FEATUREID), FLEX_STUDY_TAG),
        // style: this.props.field.style,
        selectedStudy,
        hideWeightType,
      }));
    } else if (menuName === 'Stories') {
      const studyList = filterStudyList(nextProps.studies, STORIES_FEATUREID);
      if (!_.isEmpty(nextProps.userPreference) && nextProps.userPreference._st._ds !== -1) {
        selectedStudy = getStudyFromStudies(studyList, nextProps.userPreference._st._ds);
      } else {
        selectedStudy = studyList[0].sl[0];
      }
      selectedStudy = {
        ...selectedStudy,
        wt:
        nextProps.userPreference[PREFERENCE_STORIES][PREFERENCE_STUDY_WEIGHTING]
        === 'Population' ?
        1 : 2,
      };
      const hideWeightType = this.props.weightTypeStudies &&
      this.props.weightTypeStudies.some(el => {
        return el.pn === selectedStudy.pn;
      });
      const studyFamilyId = getStudyFamilyIdForGivenProductNo(
        selectedStudy.pn, filterStudies(filterStudyList(this.props.studies, STORIES_FEATUREID), FLEX_STUDY_TAG));
      const updatedWeightType = nextProps.userPreference[PREFERENCE_STORIES][PREFERENCE_STUDY_WEIGHTING];
      if (typeof (updatedWeightType) === 'object') {
        updatedWeightType.sd = studyFamilyId;
      }
      this.props.studyActions.updateWeightType(menuName, updatedWeightType);
      this.setState(() => ({
        studies: filterStudies(filterStudyList(this.props.studies, STORIES_FEATUREID), FLEX_STUDY_TAG),
        // style: this.props.field.style,
        selectedStudy,
        hideWeightType,
      }));
    } else if (menuName === 'BrandCatalyst') {
      let selectedStudy;
      const studyList = filterStudyList(nextProps.bcStudies, BRAND_CATALYST_FEATUREID);
      if (!_.isEmpty(nextProps.userPreference) && nextProps.userPreference._bc._ds !== -1) {
        selectedStudy = getStudyFromStudies(studyList, nextProps.userPreference._bc._ds);
      } else {
        selectedStudy = _.cloneDeep(studyList[0].sl[0]);
      }
      this.setState(() => ({
        studies: studyList,
        // style: this.props.field.style,
        selectedStudy,
      }));
    } else if (menuName === 'SalesCatalyst') {
      let selectedStudy;
      const studyList = filterStudyList(nextProps.scStudies, SALES_CATALYST_FEATUREID);
      if (!_.isEmpty(nextProps.userPreference) && nextProps.userPreference._sc._ds !== -1) {
        selectedStudy = getStudyFromStudies(studyList, nextProps.userPreference._sc._ds);
      } else {
        selectedStudy = _.cloneDeep(studyList[0].sl[0]);
      }
      this.setState(() => ({
        studies: studyList,
        // style: this.props.field.style,
        selectedStudy,
      }));
    }
  }

  hideWeightTypeIfKidsStudy = selectedStudy => {
    const hideWeightType = this.props.weightTypeStudies && this.props.weightTypeStudies.some(el => {
      return el.pn === selectedStudy.pn;
    });
    this.setState(() => ({ hideWeightType }));
    if (hideWeightType) {
      return 'Population';
    }
    const keys = this.props.field.dbKey.split('.');
    let activeScreen;
    if (keys[0] === PREFERENCE_CROSSTAB) {
      activeScreen = PREFERENCE_CROSSTAB;
    } else if (keys[0] === PREFERENCE_QUICKREPORTS) {
      activeScreen = PREFERENCE_QUICKREPORTS;
    } else if (keys[0] === PREFERENCE_DATAHAUL) {
      activeScreen = PREFERENCE_DATAHAUL;
    } else if (keys[0] === PREFERENCE_STORIES) {
      activeScreen = PREFERENCE_STORIES;
    }
    return this.props.modifiedPreferences[activeScreen][PREFERENCE_STUDY_WEIGHTING];
  }

  /* updatePreferences = (selectedStudy, autoUpdate) => {
    this.setState({ selectedStudy });
    let weightType;
    if (this.props.field.menuName !== 'BrandCatalyst' &&
    this.props.field.menuName !== 'SalesCatalyst') {
      weightType = this.hideWeightTypeIfKidsStudy(selectedStudy);
    }
    this.props.updatePreferences(
      this.props.field.dbKey,
      selectedStudy.pn,
      weightType,
      autoUpdate
    );
  } */

  updatePreferences = (selectedStudy, type, autoUpdate, updatedWeightType) => {
    if (type === 'studyChange') {
      this.setState({ selectedStudy });
        // this.props.studyActions.updateWeightType(this.props.field.menuName, selectedStudy.cw[0]);
      this.setState({ selectedWeightType: updatedWeightType });
      /* if (this.props.field.menuName !== 'BrandCatalyst' &&
      this.props.field.menuName !== 'SalesCatalyst') {
        weightType = this.hideWeightTypeIfKidsStudy(selectedStudy);
      } */
      this.props.updatePreferences(
        this.props.field.dbKey,
        selectedStudy.pn,
        updatedWeightType,
        autoUpdate
      );
    } else {
      const keys = this.props.field.dbKey.split('.');
      const dbKey = `${keys[0]}._sw`;
      const weightType = selectedStudy;
      this.setState({ selectedWeightType: weightType });
      this.props.updatePreferences(
        dbKey,
        selectedStudy,
        weightType,
        autoUpdate
      );
    }
  }

  handleChangeWeightType = weightType => {
    const updatedWeight = weightType === 1 ? 'Population' : 'Household';
    const keys = this.props.field.dbKey.split('.');
    let activeScreen;
    if (keys[0] === PREFERENCE_CROSSTAB) {
      activeScreen = PREFERENCE_CROSSTAB;
    } else if (keys[0] === PREFERENCE_QUICKREPORTS) {
      activeScreen = PREFERENCE_QUICKREPORTS;
    } else if (keys[0] === PREFERENCE_DATAHAUL) {
      activeScreen = PREFERENCE_DATAHAUL;
    } else if (keys[0] === PREFERENCE_STORIES) {
      activeScreen = PREFERENCE_STORIES;
    }
    const dbKey = `${activeScreen}.${PREFERENCE_STUDY_WEIGHTING}`;
    this.props.updatePreferences(dbKey, updatedWeight);
  }

  render() {
    const { style, showWeighting } = this.props.field;
    let feature = CROSSTAB_FEATUREID;
    const fromPref = true;

    if (this.props.field.menuName === 'MME') {
      feature = MME_FEATUREID;
    } else if (this.props.field.menuName === 'QuickReports') {
      feature = QUICKREPORTS_FEATUREID;
    } else if (this.props.field.menuName === 'DataHaul') {
      feature = DATAHAUL_FEATUREID;
    } else if (this.props.field.menuName === 'Stories') {
      feature = STORIES_FEATUREID;
    } else if (this.props.field.menuName === 'BrandCatalyst') {
      feature = BRAND_CATALYST_FEATUREID;
    } else if (this.props.field.menuName === 'SalesCatalyst') {
      feature = SALES_CATALYST_FEATUREID;
    }
    return (
      <div>
        <CommonStudySelector
          studies={this.state.studies}
          featureID={feature}
          style={style}
          defaultStudy={this.state.selectedStudy}
          setMethod={this.updatePreferences}
          showWeighting={showWeighting}
          autoUpdate={this.props.autoUpdate}
          latestStudies={this.props.latestStudies}
          menuName={this.props.field.menuName}
          showWeightType={this.state.showWeightType}
          hideWeightType={this.state.hideWeightType}
          handleChangeWeightType={this.handleChangeWeightType}
          fromPref={fromPref}
          selectedWeightType={this.state.selectedWeightType}
        />
      </div>
    );
  }
}

PreferencesCommonStudySelector.propTypes = {
  field: PropTypes.shape({
    menuName: PropTypes.string,
    style: PropTypes.shape({}),
    defaultValue: PropTypes.number,
    dbKey: PropTypes.string,
    showWeighting: PropTypes.bool,
  }),
  studyActions: PropTypes.shape({
    getStudies: PropTypes.func,
    updateWeightType: PropTypes.func,
  }),
  salesCatalystActions: PropTypes.shape({
    getsalesCatalystStudy: PropTypes.func,
  }),
  insight360Actions: PropTypes.shape({
    get360Study: PropTypes.func,
  }),
  studies: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    length: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  bcStudies: PropTypes.arrayOf(PropTypes.shape({
    sl: PropTypes.arrayOf(PropTypes.shape({}))
  })),
  scStudies: PropTypes.arrayOf(PropTypes.shape({
    sl: PropTypes.arrayOf(PropTypes.shape({}))
  })),
  weightTypeStudies: PropTypes.arrayOf(PropTypes.shape({})),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  updatePreferences: PropTypes.func,
  // handleWeightTypes: PropTypes.func,
  userPreference: PropTypes.shape({}),
  modifiedPreferences: PropTypes.shape({}),
  autoUpdate: PropTypes.shape({}),
  latestStudies: PropTypes.shape({}),
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    studies: state.study.studies,
    bcStudies: state.study.insight360studies,
    scStudies: state.study.salesCatalystStudies,
    weightTypeStudies: state.study.weightTypeStudies,
    userPreference: state.preferences.userPreferences,
    study: state.study,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(PreferencesCommonStudySelector);
